<mat-toolbar class="mat-primary">
  <span fxFlex>Inbetriebnahme löschen?</span>
  <mat-icon class="cursor-mat-element" (click)="cancel()">close</mat-icon>
</mat-toolbar>
<mat-dialog-content>
  <h3 class="question">Sind Sie sicher, dass Sie die Inbetriebnahme löschen möchten?</h3>

  <app-hint-card *ngIf="showP14aWarning" [outlined]="true" [type]="'warning'">
    <p>
      <strong>Achtung:</strong>
      Die Inbetriebnahme ist bereits eingereicht und mit einer Netzanmeldung verknüpft.
    </p>
    <p>
      Wenn es sich hierbei um eine noch nicht abgeschlossene §14a-Netzanmeldung handelt, kann diese nach dem
      Löschen wieder ablaufen.
    </p>
  </app-hint-card>

  <div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
    <button mat-stroked-button color="primary" id="modal-cancel-button" (click)="cancel()">Abbrechen</button>
    <button mat-raised-button color="primary" id="modal-confirm-button" (click)="confirm()">
      Löschen bestätigen
    </button>
  </div>
</mat-dialog-content>
